import { Alert, Box, Button, Card, CardContent, CircularProgress, Typography } from "@mui/material";
import { Google as GoogleIcon } from "@mui/icons-material";
import { useAuth } from "@/hooks/useAuth";
import { brand } from "@/theme";

export default function Login() {
  const { signInWithGoogle, loading, error } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: brand.cream,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: brand.cream,
      }}
    >
      <Card sx={{ maxWidth: 420, width: "100%", mx: 2 }}>
        <CardContent sx={{ textAlign: "center", py: 5, px: 4 }}>
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h3"
              sx={{ fontFamily: "'Playfair Display', serif", color: brand.forestGreen }}
            >
              Mastermind
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
              Elite Mind Agent Management Platform
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2, textAlign: "left" }}>
              {error}
            </Alert>
          )}

          <Button
            variant="contained"
            size="large"
            startIcon={<GoogleIcon />}
            onClick={signInWithGoogle}
            sx={{
              py: 1.5,
              px: 4,
              bgcolor: brand.forestGreen,
              "&:hover": { bgcolor: "#153025" },
            }}
          >
            Sign in with Google
          </Button>

          <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 3 }}>
            Access restricted to Elite Mind team members.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
